import { Edge } from "../lib/edge";
import { Grid } from "../lib/grid";
import { Node } from "../lib/node";


export class SymmetricWeightedEdge extends Edge {
    protected unit: string = "";

    constructor(from: Node, to: Node) {
        super(from, to);
        this.weight = 0;
    }

    draw(ctx: CanvasRenderingContext2D, grid: Grid) {
        super.draw(ctx, grid);

        ctx.save();
        ctx.fillStyle = 'black';
        ctx.textAlign = "start";
        ctx.font = 'bold ' + (grid.getHeightCell() / 4) + 'px Arial';
        ctx.fillStyle = this.color;
        let midEdge: [number, number] = this.getCoordinateOnEdge(0.5, grid);
        ctx.fillText("" + this.weight + this.unit, midEdge[0], midEdge[1]);
        ctx.restore();
    }

    setUnit(unit: string) {
        this.unit = unit;
    }

    getUnit(): string {
        return this.unit;
    }

    /**
     * 
     * @param percent, percent = 1.0 end of the edge, percent = 0.5 in the middle of the edge
     */
    getCoordinateOnEdge(percent: number, grid: Grid): [number, number] {
        let bezier1: [number, number] = grid.convertCoordinateToRaw(
            this.bezierPoint.point1Coord[0], this.bezierPoint.point1Coord[1]
        );

        let bezier2: [number, number] = grid.convertCoordinateToRaw(
            this.bezierPoint.point2Coord[0], this.bezierPoint.point2Coord[1]
        );

        var from: [number, number] = this.getCenterFrom(grid);
        var to: [number, number] = this.getCenterTo(grid);;

        var coord = this.getBezierCoordinates(percent, from[0], from[1], bezier1[0], bezier1[1], bezier2[0], bezier2[1], to[0], to[1]);

        let res: [number, number]
        if (this.isBezier)
            if (Math.abs(from[1] - to[1]) >= 0.3) {
                res = [coord.x + grid.getHeightCell() / 2.5, coord.y];
            }
            else {
                res = [coord.x, coord.y + grid.getHeightCell() / 2.5];

            }
        else {
            if (Math.abs(from[1] - to[1]) >= 0.3) {
                res = [((from[0] + to[0]) / 2) + grid.getHeightCell() / 2.5, (from[1] + to[1]) / 2]
            } else {
                res = [((from[0] + to[0]) / 2), ((from[1] + to[1]) / 2) + grid.getHeightCell() / 2.5]
            }
        }
        return res;
    }

    getCenterFrom(grid: Grid): [number, number] {
        return grid.getCellCenter(this.from.getRowIndex(), this.from.getColIndex());
    }

    getCenterTo(grid: Grid): [number, number] {
        return grid.getCellCenter(this.to.getRowIndex(), this.to.getColIndex());;
    }
}

